module.exports = __webpack_public_path__ + "static/booking-22-799be950f01287d64d32f7c2e10c2316.svg";